enum AttributeType {
    STRING = 'STRING',
    HTML = 'HTML',
    BOOLEAN = 'BOOLEAN',
    QUANTITY = 'QUANTITY',
    NUMERIC = 'NUMERIC',
}

enum DiscountType {
    None = 'None',
    StrikePrice = 'StrikePrice',
    FriendDiscount = 'FriendDiscount',
}

enum ProductType {
    EXPERIENCE = 'EXPERIENCE',
    BOX = 'BOX',
    VALUE_VOUCHER = 'VALUE_VOUCHER',
}

enum ShippingMethodType {
    online = 'online',
    express = 'express',
    standard = 'standard',
    box_express = 'box_express',
    box_standard = 'box_standard',
}

enum XmasNoticeType {
    ShippingNoticeStandardOn = 'SHIPPING_NOTICE_STANDARD_ON',
    XmasNoticeDeOn = 'XMAS_DE_ON',
    ShippingNoticeDEOn = 'SHIPPING_NOTICE_DE_ON',
}

export { AttributeType, DiscountType, ProductType, ShippingMethodType, XmasNoticeType };
